export default __webpack_public_path__ + "static/media/skis.80fcd158.png";